import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

export const SearchInput = ({ allowClear, value, handleSearch }) => {
  const onChange = e => {
    handleSearch(e.target.value);
  };

  return (
    <SearchFieldWrapper className="search-field--wrapper">
      <SearchInputField
        allowClear={allowClear}
        placeholder="Search"
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)', fontSize: '20px' }} />}
        onChange={onChange}
        height={62}
        value={value}
      />
    </SearchFieldWrapper>
  );
};

const SearchFieldWrapper = styled.div`
  margin-top: 0px;
  margin-left: 0px;
  position: relative;
  font-size: 20px;
  width: 400px;

  .ant-input-prefix {
    display: flex;
    align-items: center;
  }

  .ant-input-affix-wrapper {
    .ant-input {
      padding-left: 20px !important;
    }
  }

  @media (max-width: 992px) {
    width: 100%;
  }
`;

const SearchInputField = styled(Input)`
  height: ${({ height }) => (height ? '${height}px !important' : '64px !important')};
  border-radius: 0px !important;
  font-family: Sofia Pro;
  font-size: 20px !important;
  letter-spacing: 1.1px;
`;
